'use es6';

import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4;

import breakpoint from '../../utils/responsiveBreakpoints';
import styled from 'styled-components';
import { TAB_IDS } from '../../constants/Mon569SidenavConfig';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { useParams } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
const SelectorButton = styled(UIRouterButton).withConfig({
  displayName: "Mon569MobileProductLevelSelector__SelectorButton",
  componentId: "sc-1efngqv-0"
})(["font-size:0.75rem;flex-grow:1;flex-basis:33%;background-color:transparent !important;border:1px solid ", " !important;transition:background-color 0.3s;padding:25px !important;&:nth-child(1n){display:flex !important;justify-content:center;align-items:center;}&:first-child{margin-right:-1px;border-radius:3px 0 0 3px;}&:last-child{margin-left:-1px;border-radius:0 3px 3px 0;}&:hover{background-color:#e5f5f8 !important;}&.active{font-weight:500;border-width:2px !important;border-color:#00a4bd !important;background-color:#e5f5f8 !important;}", " ", ""], CALYPSO_MEDIUM, breakpoint.tabletPortrait(_t || (_t = _`
    margin-left: 0 !important;
    &:first-child {
      margin-bottom: 10px;
    }
`)), breakpoint.phoneLarge(_t2 || (_t2 = _`
    width: 100%;
    &:first-child {
      border-radius: 3px 3px 0 0 !important;
    }
    &:last-child {
      margin-left: 0;
      border-radius: 0 0 3px 3px !important;
    }
  `)));
const SelectorButtonWrapper = styled.div.withConfig({
  displayName: "Mon569MobileProductLevelSelector__SelectorButtonWrapper",
  componentId: "sc-1efngqv-1"
})(["display:flex;width:100%;margin:0 auto;", " ", ""], breakpoint.tabletPortrait(_t3 || (_t3 = _`
    flex-direction: column;
    width: 80%;
  `)), breakpoint.phone(_t4 || (_t4 = _`
    width: -webkit-fill-available;
  `)));

const MobileSelectorButton = ({
  tabId,
  productLine,
  isSuite
}) => {
  const pageParam = isSuite ? 'suite' : productLine.toLowerCase();
  const {
    tab: selectedTab
  } = useParams();
  const selectedNavItem = productLine.toLowerCase();
  const langKey = isValidI18nKey(`mon569.tabTitle.${selectedNavItem}.${tabId}`) ? selectedNavItem : 'default';
  return /*#__PURE__*/_jsx(SelectorButton, {
    className: selectedTab === tabId ? 'active' : '',
    to: `/${pageParam}/${tabId}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `mon569.tabTitle.${langKey}.${tabId}`
    })
  });
};

const Mon569MobileProductLevelSelector = ({
  productLine,
  isSuite
}) => {
  return /*#__PURE__*/_jsx(SelectorButtonWrapper, {
    children: Object.keys(TAB_IDS).map(id => /*#__PURE__*/_jsx(MobileSelectorButton, {
      tabId: id,
      productLine: productLine,
      isSuite: isSuite
    }, id))
  });
};

export default Mon569MobileProductLevelSelector;